import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/core-js/modules/es6.array.iterator.js";
import "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/core-js/modules/es6.promise.js";
import "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/core-js/modules/es6.object.assign.js";
import "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/core-js/modules/es7.promise.finally.js";
// import {mark, measure} from './util/performance'
import '@/config/index';
import Vue from 'vue';
import { createApp } from "./app";
import "./util/DataRequest";
import util from '@tencent/vft-common/util';
import ImgPlugin from '@tencent/vft-vue-plugins/src/img/v-img';
import dialogPlugin from '@tencent/vft-vue-plugins/src/dialog';
import LoginPanel from '@tencent/vft-component/LoginPanel';
import * as eggService from '@/services/eggService';

// const dialogModule = () => import('@tencent/vft-vue-plugins/src/dialog')
// const loginModule = () => import('@tencent/vft-component/LoginPanel')

// 加入openVueDevtool参数可在生产环境开启vue-devtool
if (location.href.indexOf('openVueDevtool') >= 0) {
  Vue.config.devtools = true;
  Vue.config.performance = true;
  window.__VUE_DEVTOOLS_GLOBAL_HOOK__.emit('init', Vue);
}
try {
  window.mountFirstPaint = performance.now();
  window.aegis.reportTime('首屏mounted时间', window.mountFirstPaint);
} catch (error) {
  console.log('aegis上报时间报错：', window.mountFirstPaint);
}
var _createApp = createApp(),
  app = _createApp.app,
  store = _createApp.store;

// 上报配置中需要获取到store对象
window.store = store;

// Vue.config.productionTip = false
Vue.use(dialogPlugin);
// dialogModule().then(({ default: dialogPlugin }) => {
// })

Vue.use(ImgPlugin);
Vue.mixin({
  methods: {
    initShareInfo: function () {
      var _initShareInfo = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(msg) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!this.share || !this.share.setShare)) {
                  _context.next = 2;
                  break;
                }
                return _context.abrupt("return");
              case 2:
                this.share.setShare({
                  imgUrl: 'https://puui.qpic.cn/vupload/0/20181127_1543305921463_7wljcvwqttf.png/0',
                  title: "\u817E\u8BAF\u89C6\u9891VIP\u798F\u5229\u793E",
                  desc: "\u798F\u5229\u6DB5\u76D6\u5403\u559D\u73A9\u4E50\uFF0C\u8863\u98DF\u4F4F\u884C\uFF01\u6211\u8981\u5E26\u4F60\u98DE\uFF0C\u7EDD\u5BF9\u4E0D\u662F\u5439\uFF01",
                  link: location.href
                });
              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function initShareInfo(_x) {
        return _initShareInfo.apply(this, arguments);
      }
      return initShareInfo;
    }()
  }
});
function handleSamePage() {
  /* 为了防止浏览器缓存html，导致后退时没有重新请求新的页面片，这里需要特别处理
   * 服务端会返回每次请求的时间戳作为requestId，如果requestId和sessionStorage里的一致，说明是没有重新请求，需要改为客户端渲染逻辑
   */
  var isSamePage = sessionStorage.getItem('welfare-requestId') === window.requestId;
  if (isSamePage) {
    window.__INITIAL_STATE__ = undefined;
    document.getElementById('app').innerHTML = '';
  }
  sessionStorage.setItem('welfare-requestId', window.requestId);
}
handleSamePage();
var isInit = false;
if (window.__INITIAL_STATE__) {
  store.replaceState(window.__INITIAL_STATE__);
}
if (util.getUrlParam('subPageInfo')) {
  store.commit('saveIsSubPage', true);
}
function init() {
  return _init.apply(this, arguments);
}
function _init() {
  _init = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
    var div, setting, actId;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!isInit) {
              _context2.next = 2;
              break;
            }
            return _context2.abrupt("return");
          case 2:
            isInit = true;
            Vue.use(LoginPanel);
            if (!document.getElementById('app')) {
              div = document.createElement('div');
              div.id = 'app';
              document.body.appendChild(div);
            }
            if (window.__INITIAL_STATE__ && window.__INITIAL_STATE__.indexPageModule && window.__INITIAL_STATE__.indexPageModule.serverSetting) {
              setting = window.__INITIAL_STATE__.indexPageModule.serverSetting['福利社摇蛋'] || {};
              actId = setting.活动Id;
              if (actId) {
                eggService.setActId(actId);
              }
            }
            app.$mount('#app', !!window.__INITIAL_STATE__);
            store.dispatch('getPayVipAndUserInfo');
            window.mounted = true;
            try {
              window.aegis.reportTime('静态资源');
            } catch (error) {
              console.log('client-entry, aegis report time 报错');
            }
          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _init.apply(this, arguments);
}
init().catch(function (err) {
  console.error(err);
});
window.addEventListener('unload', function () {
  console.log('try to make browser backward cache invalid');
});